var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas",staticStyle:{"object-fit":"contain","width":"100%","border":"1px solid #000000"},attrs:{"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }